import React from "react";
import { Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

import "./Footer.css";

const legalLinks = [
  { to: "/envios-y-devoluciones", label: "Informacion de atencion" },
  { to: "/condiciones-generales", label: "Condiciones de uso" },
  { to: "/politica-de-privacidad", label: "Politica de Privacidad y Cookies" },
];

const Footer = () => {
  return (
    <footer className="footer">
      <Container className="footer-shell">
        <div className="footer-main">
          <div className="footer-brand">
            <Link to="/" className="footer-logo" aria-label="Ir al inicio">
              W&Co.
            </Link>
            <p className="footer-copy">
              Whiskys elegidos con criterio, caracter y oficio. Una seleccion pensada para descubrir etiquetas con historia propia.
            </p>
          </div>

          <div className="footer-social-panel" aria-label="Canales de contacto">
            <a
              href="https://www.instagram.com/whiskyandco_/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-link"
              aria-label="Instagram de Whisky and Co"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a
              href="https://wa.me/5493515295096"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-link"
              aria-label="WhatsApp de Whisky and Co"
            >
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>
          </div>

          <address className="footer-contact">
            <a href="tel:+543515295096" className="footer-contact-link">
              <span className="footer-contact-icon">
                <FontAwesomeIcon icon={faPhone} />
              </span>
              <span>+54 3515295096</span>
            </a>
            <a
              className="footer-contact-link"
              href="https://maps.app.goo.gl/GkZN29pu5y3tk7LP7"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="footer-contact-icon">
                <FontAwesomeIcon icon={faLocationDot} />
              </span>
              <span>
                Av. Recta Martinolli 8669
                <small>Cordoba, Argentina 5021</small>
              </span>
            </a>
          </address>
        </div>

        <div className="footer-bottom">
          <p className="footer-rights">
            &copy; {new Date().getFullYear()} Whisky & Co.
          </p>

          <nav className="footer-legal" aria-label="Enlaces legales">
            {legalLinks.map((link) => (
              <Link key={link.to} to={link.to} className="legalesS">
                {link.label}
              </Link>
            ))}
          </nav>

          <a
            href="https://senestraridev.com"
            target="_blank"
            rel="noopener noreferrer"
            className="developer-link"
            aria-label="Sitio de Senestrari Dev"
          >
            <span>Powered by</span>
            <img
              src="/img/marca/logoSenestraridevH.webp"
              alt="Senestrari Dev"
              className="logoSenestrariDev"
            />
          </a>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
